import axios from 'axios';

const BASE_FUNNEL = '/app/funnel';

export const getLabelsFromTimeZoneChanged = async (oldTimeZoneId, newTimeZoneId) => {
    const params = new URLSearchParams({
        oldTimeZoneId,
        newTimeZoneId,
    }).toString();

    const { data } = await axios.get(`${BASE_FUNNEL}/timeZone/changed?${params}`);

    return data;
};
